import { render, staticRenderFns } from "./CommissionsTable.vue?vue&type=template&id=5b14fd84&"
import script from "./CommissionsTable.vue?vue&type=script&lang=js&"
export * from "./CommissionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports